<template>
  <div style="width: 100%;height: 100vh;display: flex;justify-content: center;align-items: center;background-color: #FFFFFF;">
    <div style="text-align: center;">
      <img src="../../assets/vip.jpg" style="width: 40vw;" />
      <button style="padding: 5px 20px; border: 1px solid #A5865F;margin-top: 16px;background:none;outline: none;color: #A5865F;" @click="toWXBuyCard()" type="button">立即前往</button>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {


      }
    },
    created() {

    },
    mounted() {
      this.toWXBuyCard()
    },
    watch: {

    },
    methods: {

      toWXBuyCard(){
        // toolgetUrlScheme
        var $this = this
        // this.$loading('加载中');
        let param = {
          path: 'pages/vip/vip',
          query:'cardtype=C'
        }
        var qs = require('qs');
        let url = this.api.userApi.toolgetUrlScheme
        // console.log('flGetUserInfoByOpenid')
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.code==200) {
            location.href=result.data.openlink
          } else {
            // $this.$loading.close()
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$loading.close()
          // $this.$toast('error');
        })
        // window.location.href='weixin://dl/business/?t=wYfWQ1ZbZnn'
        // this.$dialog.alert({
        //   title: '提示',
        //   message: '等小程序上线后才会有链接跳转',
        // }).then(() => {
        //   // on close
        // });
      }
    },
    destroyed() {

    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;

</style>



// WEBPACK FOOTER //
// src/components/monthcard/diamonds.vue